import * as React from 'react';
import { useDashboardSlice } from '../../slice';
import {
  Users,
  ShoppingCart,
  FileText,
  UserPlus,
  ShoppingBag,
} from 'lucide-react';
import { Link } from 'react-router-dom';
export function Stats() {
  const { useGetStatsQuery } = useDashboardSlice();
  const [getStats, { data: response, error, isLoading }] = useGetStatsQuery();

  React.useEffect(() => {
    getStats({});
  }, []);

  const [stats, setStats] = React.useState([
    {
      title: 'Total Users',
      count: 0,
      icon: <Users size={20} className="text-sky-600" />,
      bgColor: 'bg-sky-50',
      borderColor: 'border-sky-50',
      link: '/users',
    },
    {
      title: 'Total Orders',
      count: 0,
      icon: <ShoppingCart size={20} className="text-green-600" />,
      bgColor: 'bg-green-50',
      borderColor: 'border-green-50',
      link: '/orders',
    },
    {
      title: 'Total Files',
      count: 0,
      icon: <FileText size={20} className="text-purple-600" />,
      bgColor: 'bg-purple-50',
      borderColor: 'border-purple-50',
      link: '/files',
    },
    {
      title: "Today's New Users",
      count: 0,
      icon: <UserPlus size={20} className="text-pink-600" />,
      bgColor: 'bg-pink-50',
      borderColor: 'border-pink-50',
      link: '/users',
    },
    {
      title: "Today's Orders",
      count: 0,
      icon: <ShoppingBag size={20} className="text-yellow-50" />,
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-50',
      link: '/orders',
    },
  ]);

  React.useEffect(() => {
    if (response?.data) {
      setStats([
        {
          title: 'Total Users',
          count: response.data.totalUsers || 0,
          icon: <Users size={20} className="text-sky-600" />,
          bgColor: 'bg-sky-50',
          borderColor: 'border-sky-50',
          link: '/users',
        },
        {
          title: 'Total Orders',
          count: response.data.totalOrders || 0,
          icon: <ShoppingCart size={20} className="text-green-600" />,
          bgColor: 'bg-green-50',
          borderColor: 'border-green-50',
          link: '/orders',
        },
        {
          title: 'Total Files',
          count: response.data.totalFiles || 0,
          icon: <FileText size={20} className="text-purple-600" />,
          bgColor: 'bg-purple-50',
          borderColor: 'border-purple-50',
          link: '/files',
        },
        {
          title: "Today's New Users",
          count: response.data.todayUserSignups || 0,
          icon: <UserPlus size={20} className="text-pink-600" />,
          bgColor: 'bg-pink-50',
          borderColor: 'border-pink-50',
          link: '/users',
        },
        {
          title: "Today's Orders",
          count: response.data.todayOrders || 0,
          icon: <ShoppingBag size={20} className="text-yellow-600" />,
          bgColor: 'bg-yellow-50',
          borderColor: 'border-yellow-50',
          link: '/orders',
        },
      ]);
    }
  }, [response]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-5 mb-5">
      {stats.map(stat => (
        <div
          key={stat.title}
          className={`rounded-2xl shadow-sm overflow-hidden border ${stat.borderColor} bg-white  dark:bg-transparent`}
        >
          <Link to={stat.link}>
            <div
              className={`flex items-center justify-between px-4 py-3 ${stat.bgColor}`}
            >
              <div className="text-sm font-medium text-gray-700">
                {stat.title}
              </div>
              <div
                className={`p-2 rounded-full bg-white  dark:bg-transparent border ${stat.borderColor}`}
              >
                {stat.icon}
              </div>
            </div>
            <div className="px-4 py-5 bg-white  dark:bg-transparent">
              <div className="text-2xl font-bold text-gray-900">
                {stat.count}
              </div>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}
